import { render } from "./SmartControl.vue?vue&type=template&id=56510d86&scoped=true&lang=pug"
import script from "./SmartControl.vue?vue&type=script&lang=js"
export * from "./SmartControl.vue?vue&type=script&lang=js"

import "./SmartControl.vue?vue&type=style&index=0&id=56510d86&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56510d86"]])

export default __exports__